import { useEffect, useState } from "react";
import { useFormContext } from "react-hook-form";
import { formatISO } from "date-fns";

import moment from "moment";
import { Trash2 } from "lucide-react";

interface Representado {
  id: number;
  name_fantasy: string;
}

interface Props {
  representados: Representado[];
}

export function RepresentadosTable({ representados }: Props) {
  const { setValue, watch } = useFormContext();
  const [selected, setSelected] = useState<number | null>(null);
  const [dataInit, setDataInit] = useState("");
  const [dataEnd, setDataEnd] = useState("");
  const [items, setItems] = useState<any[]>(watch("list_representados") || []);

  useEffect(() => {
    const list = watch("list_representados") || [];
    setItems(list);
  }, [watch("list_representados")]);

  const handleAdd = () => {
    if (!selected || !dataInit || !dataEnd) return;

    const item = {
      id: selected,
      dataInit: formatISO(new Date(dataInit)),
      dataEnd: formatISO(new Date(dataEnd)),
    };

    const newList = [...items, item];
    setItems(newList);
    setValue("list_representados", newList);

    // Reset campos
    setSelected(null);
    setDataInit("");
    setDataEnd("");
  };

  const handleRemove = (id: number) => {
    const newList = items.filter((item) => item.id !== id);
    setItems(newList);
    setValue("list_representados", newList);
  };
  const getNameById = (id: number) =>
    representados.find((r) => r.id === id)?.name_fantasy || "Desconhecido";

  return (
    <div className="flex flex-col gap-4">
      <h3 className="font-semibold">Representados</h3>

      <div className="grid grid-cols-5 gap-2 items-center">
        <label className="col-span-2 flex flex-col">
          <span className="text-sm mb-1">Representado</span>
          <select
            className="h-11 bg-cinza-100 rounded-lg px-6 outline-azul-400 text-zinc-800"
            value={selected || ""}
            onChange={(e) => setSelected(Number(e.target.value))}
          >
            <option value="" disabled>
              Selecionar Representado
            </option>
            {representados.map((rep) => (
              <option key={rep.id} value={rep.id}>
                {rep.name_fantasy}
              </option>
            ))}
          </select>
        </label>

        <label className="flex flex-col">
          <span className="text-sm mb-1">Data Início</span>
          <input
            type="date"
            value={dataInit}
            className="h-11 bg-cinza-100 rounded-lg px-6 outline-azul-400 text-zinc-800"
            onChange={(e) => setDataInit(e.target.value)}
          />
        </label>

        <label className="flex flex-col">
          <span className="text-sm mb-1">Data Final</span>
          <input
            type="date"
            value={dataEnd}
            className="h-11 bg-cinza-100 rounded-lg px-6 outline-azul-400 text-zinc-800"
            onChange={(e) => setDataEnd(e.target.value)}
          />
        </label>

        <div className="flex flex-col">
          <span className="text-sm mb-1 opacity-0">.</span>{" "}
          {/* só pra alinhar */}
          <button
            type="button"
            onClick={handleAdd}
            className="bg-azul-400 text-white rounded-md py-1"
          >
            Adicionar
          </button>
        </div>
      </div>

      {items.length > 0 && (
        <table className="w-full border text-sm">
          <thead>
            <tr className="bg-azul-400 text-white">
              <th className="p-2 border">Representado</th>
              <th className="p-2 border">Data Início</th>
              <th className="p-2 border">Data Final</th>
              <th className="p-2 border">Ações</th>
            </tr>
          </thead>
          <tbody>
            {items.map((item) => (
              <tr key={item.id} className="text-center">
                <td className="p-2 border">{getNameById(item.id)}</td>
                <td className="p-2 border">
                  {moment.utc(item.dataInit).format("DD/MM/YYYY")}
                </td>
                <td className="p-2 border">
                  {moment.utc(item.dataEnd).format("DD/MM/YYYY")}
                </td>
                <td className="p-2 border">
                  <button
                    type="button"
                    className="hover:text-red-500"
                    onClick={() => handleRemove(item.id)}
                  >
                    <Trash2 size={16} />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
